import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { AuthenticationService } from '../../auth/authentication-service';
import { BaseApiService } from '../baseApiService';
import { ServiceEventDTO } from './serviceEvent';

@Injectable({
  providedIn: 'root'
})
export class ServiceEventApiService extends BaseApiService {
  constructor(http: HttpClient, authService: AuthenticationService) {
    super(http, authService);
  }

  getServiceEventsForAsset(assetId: string): Observable<ServiceEventDTO[]> {
    if (!assetId.trim()) {
      return of();
    }

    return this.http.get<ServiceEventDTO[]>(`${this.apiUrl}/api/v5/assets/${assetId}/service-events`).pipe(
      catchError(this.handleError<ServiceEventDTO[]>('getServiceEventsForAsset', undefined))
    );
  }
}
